export const OTP_ERROR_TYPES = {
    OTP_VALIDATION_FAILED: 'otp.validation.failed',
    OTP_VALIDATION_FAILED1: 'otp.validation.failed1',
    OTP_VALIDATION_FAILED2: 'otp.validation.failed2',
    DOCUMENT_TEMPORARILY_BLOCKED_EXCEPTION: 'document.temporarily.blocked.exception',
    OTP_SERVICE_UNKNOWN_EXCEPTION: 'otp.service.unknown.exception',
    OTP_AUTH_NOT_FOUND: 'otp.auth.not.found',
    OTP_GENERATION_ATTEMPTS_EXCEEDED: 'otp.generation.attempts.exceeded',
    CODE_INCORRECT: 'code.incorrect',
    CODE_INCORRECT1: 'code.incorrect1',
    CODE_INCORRECT2: 'code.incorrect2',
    OTP_VALIDATION_ATTEMPTS_LIMIT_EXCEEDED: 'otp.validation.attempts.limit.exceeded',
};
